import { useEffect, useState } from "react";

const useUserLocation = () => {
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!navigator.geolocation) {
      setError("Геолокация не поддерживается вашим устройством.");
      return;
    }

    const watchId = navigator.geolocation.watchPosition(
      (pos) => {
        setLocation({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
        });
      },
      (err) => {
        switch (err.code) {
          case err.PERMISSION_DENIED:
            setError("Вы запретили доступ к геолокации.");
            break;
          case err.POSITION_UNAVAILABLE:
            setError("Информация о местоположении недоступна.");
            break;
          case err.TIMEOUT:
            setError("Время ожидания локации истекло.");
            break;
          default:
            setError("Неизвестная ошибка при получении геолокации.");
        }
      }
    );

    return () => {
      navigator.geolocation.clearWatch(watchId);
    };
  }, []);

  return { location, error };
};

export default useUserLocation;
